import { MediaWithAlbum, SortByQueryOptions } from '@bpm-web-app/stream-api-sdk';
import { Album as DownloadAlbum } from '@bpm-web-app/download-api-sdk';
import { useFeatured } from '@bpm-web-app/swr-hooks';
import { DEFAULT_HOMEPAGE_TRACKLIST_LIMIT, useHubSwitch } from '@bpm-web-app/utils';
import { useContext, useEffect, useMemo } from 'react';
import { LibraryTabsContext } from '../../../../utils/src/lib/library-tabs.context';
import { HomepageTracklistSection } from '../shared';
import { TrackListPresetSupreme } from '../shared/track-list/supreme/track-list-supreme-helpers';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface FeaturedProps {
    isDataLoaded?: boolean;
    seeMorePath?: string
    setIsDataLoaded?: (loaded: boolean) => void;
}

export function Featured({ isDataLoaded, setIsDataLoaded, seeMorePath }: FeaturedProps) {
    const { libraryProperty } = useContext(LibraryTabsContext);
    const { isDownload } = useHubSwitch();

    /* note: limit is NOT supported by the Stream api call - we need to slice the array manually! */
    const { data, isLoading } = useFeatured({
        limit: 20,
        sort_by: SortByQueryOptions.DateDesc,
        library: libraryProperty,
    });

    const featured = data?.data.slice(0, DEFAULT_HOMEPAGE_TRACKLIST_LIMIT);

    useEffect(() => {
        if (setIsDataLoaded) {
            if (isLoading === false) {
                setIsDataLoaded(true);
            } else {
                setIsDataLoaded(false);
            }
        }
    }, [isLoading, setIsDataLoaded]);

    const shouldDisplayGhostLoading = useMemo(() => isDataLoaded === false || isLoading, [isDataLoaded, isLoading]);

    return (
        <HomepageTracklistSection
            title="New Music"
            href={seeMorePath || '/new-music/all'}
            list={featured as DownloadAlbum[] | MediaWithAlbum[]}
            preset={isDownload ? TrackListPresetSupreme.Download : TrackListPresetSupreme.Stream}
            isLoading={shouldDisplayGhostLoading}
        />
    );
}

export default Featured;
